import { useTranslations } from '@vocab/react';

import { FieldList } from '../FieldList/FieldList';

import translations from './.vocab';

interface Props {
  workHistories: Array<{
    companyName: string;
    roleTitle: string;
    duration?: string;
    achievements?: string;
    foundInCV?: boolean;
  }>;
}

export const CareerHistory = ({ workHistories }: Props) => {
  const { t } = useTranslations(translations);
  return (
    <FieldList
      icon="workExperience"
      iconTone="brandAccent"
      descriptionSize="smallMobile"
      fields={
        workHistories
          ? workHistories.map(
              ({
                companyName,
                roleTitle,
                duration,
                achievements,
                foundInCV,
              }) => ({
                heading: foundInCV
                  ? `${t('FOUND_IN_CV')} ${roleTitle}`
                  : roleTitle,
                subHeading: companyName,
                subHeadingSecondary: duration,
                description: achievements,
                isEmphasized: foundInCV,
              }),
            )
          : []
      }
    />
  );
};
